module.exports = __webpack_public_path__ + "static/Averta-Regular-a4ee004458777c24b3b34c54da7a2185.ttf";